const ArrayUtil = {
  /**
   * @param {Array} arr
   * @returns {Array}
   */
  uniqueArr: arr => {
    return Array.from(new Set(arr))
  },
  uniqueArr2: arr => {
    const obj = {}
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i]
      if (obj[item] !== undefined) {
        arr.splice(i, 1)
        i-- // 解决删除元素后，数组塌陷问题
        continue
      }
      obj[item] = item
    }
  },
  /**
   * Merges two objects, giving the last one precedence
   * @param {Object} target
   * @param {(Object|Array)} source
   * @returns {Object}
   */
  objectMerge: (target, source) => {
    if (typeof target !== 'object') {
      target = {}
    }
    if (Array.isArray(source)) {
      return source.slice()
    }
    Object.keys(source).forEach(property => {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = ArrayUtil.objectMerge(target[property], sourceProperty)
      } else {
        target[property] = sourceProperty
      }
    })
    return target
  },
  /**
   * @param {Array} actual
   * @returns {Array}
   */
  cleanArray: actual => {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i])
      }
    }
    return newArray
  },
  /**
   * 验证重复元素，有重复返回true；否则返回false
   */
  isRepeat: arr => {
    const obj = {}
    for (const i in arr) {
      if (obj[arr[i]]) {
        return true
      }
      // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
      obj[arr[i]] = true
    }
    return false
  }
}

export { ArrayUtil }
